module.exports = "/_next/static/resources/photo-1-80f44a4628c37da12e019e9fc28b32b3.webp";